// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://optimism-sepolia.blockscout.com/address/0xb13Cfa6f8B2Eed2C37fB00fF0c1A59807C585810
export const GHO_TOKEN = '0xb13Cfa6f8B2Eed2C37fB00fF0c1A59807C585810';

// https://optimism-sepolia.blockscout.com/address/0x5f4d15d761528c57a5C30c43c1DAb26Fc5452731
export const TRANSPARENT_PROXY_FACTORY = '0x5f4d15d761528c57a5C30c43c1DAb26Fc5452731';

// https://optimism-sepolia.blockscout.com/address/0xe892E40C92c2E4D281Be59b2E6300F271d824E75
export const PROXY_ADMIN = '0xe892E40C92c2E4D281Be59b2E6300F271d824E75';

export const CHAIN_ID = 11155420;
